import AppContext from "~/contexts/App"
import { useContext, useMemo } from "react"

const useReadOnly = () => {
  const { authUser } = useContext(AppContext)

  return useMemo(() => {
    if (authUser?.permission_group === "read-only") {
      return true
    }
    return false
  }, [authUser])
}
export default useReadOnly
